module.exports = __webpack_public_path__ + "img/201219_TUTORIAL-08.8563094e.jpg";